const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onPatientSelectionSuccess: (chosenPatientId) => {
        dispatchProps._onPatientSelectionSuccess(
            chosenPatientId,
            stateProps.bookingState
        );
    },
});

export default mergeProps;
